import { AxiosError, AxiosResponse } from 'axios'
import useSWR, { SWRConfiguration } from 'swr'
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'

import {
    GetCardResponseEntity, PatchCardRequestEntity, PatchCardResponseEntity, PostCardRequestEntity,
    PostCardResponseEntity
} from '../entities/card'
import app from './app'

export default {
    useFetchSWR: (cardId?: string, config?: SWRConfiguration) => useSWR(cardId ? `/cards/${cardId}` : null, url => app({ authorized: 'disable' }).get<GetCardResponseEntity>(url).then(r => r.data), config),

    useSearchSWR: (query: { profileId?: string }, config?: SWRConfiguration) => useSWR(query.profileId ? `/cards?profile_id=${encodeURIComponent(query.profileId)}` : null, url => app({ authorized: 'disable' }).get<GetCardResponseEntity>(url).then(r => r.data), config),

    useInsertSWR: (config?: SWRMutationConfiguration<AxiosResponse<PostCardResponseEntity, PostCardRequestEntity>, AxiosError>) => useSWRMutation('/cards', (url: string, { arg }: { arg: PostCardRequestEntity }) => app({ authorized: 'required' }).post<PostCardResponseEntity>(url, arg), config),

    useModifySWR: (cardId?: string, config?: SWRMutationConfiguration<AxiosResponse<PatchCardResponseEntity, PatchCardRequestEntity>, AxiosError>) => useSWRMutation(cardId ? `/cards/${cardId}` : null, (url: string, { arg }: { arg: PatchCardRequestEntity }) => app({ authorized: 'required' }).patch<PatchCardResponseEntity>(url, arg), config),
}